export const AnimationsConfig = {
  bouncingBallLoader: `./assets/animations/lottiefiles/bouncing-ball-loader.json`,
  bikeRelax: `./assets/animations/lottiefiles/bike-relax.json`,
  emptyFileList: `./assets/animations/lottiefiles/empty-files-list.json`,
  mobilePayment: `./assets/animations/lottiefiles/mobile-payment.json`,
  fileUpload: `./assets/animations/lottiefiles/file-upload.json`,
};
